import React from 'react'; 
import PropTypes from 'prop-types';

const CostEstimate = ({ lookup, vacantType, reasonType, cost }) => {
    if (!lookup || !cost) return null; 
    let msg = '';
    if (cost) {        
        msg = lookup.cost && lookup.cost.price && lookup.cost.price.replace("{price}", cost);
    }
    else {
        if (reasonType == 1)
            msg = lookup.cost && lookup.cost.demolishBuildings;
        else if (reasonType == 2) {
            if (vacantType == '1')
                msg = lookup.cost && lookup.cost.otherReason;
            if (vacantType == '2')
                msg = lookup.cost && lookup.cost.notEmptyNotDemolishBuilding;
        }
    }
    return (
        <div className="form-group">
            {cost ? <h4 className="text-primary">{msg}</h4> : { msg }}
            {
                lookup.cost && lookup.cost.note ? <div dangerouslySetInnerHTML={{ __html: lookup.cost && lookup.cost.note }} /> : null
            }
        </div>
    );
};

CostEstimate.propTypes = {
    lookup: PropTypes.object.isRequired,
    vacantType: PropTypes.string,
    reasonType: PropTypes.number,
    cost: PropTypes.number,
};

export default CostEstimate; 